import { z } from "zod";
export const zCorpAdminStatus = z.enum(["ACTIVE", "BLOCKED", "DELETED"]);
export const zCorpCompanyStatus = z.enum(["ACTIVE", "SUSPENDED", "ARCHIVED"]);
export const CORP_COMPANY_STATUS_LABELS = {
    ACTIVE: "Активна",
    SUSPENDED: "Приостановлена",
    ARCHIVED: "В архиве",
};
